import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CropImage from "../cropClasse";

const useStyles = makeStyles((theme) => ({
  paper: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    border: 'solid 1px #dfdfe6',
    boxShadow: '0 24px 40px -16px rgba(6, 31, 128, 0.2)',
    zIndex: 2,
    margin: '0 auto',
  },
  backModal: {
    position: 'fixed',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0,0,0,0.8)',
    width: '100vw',
    height: '100vh',
    padding: '2rem',
    zIndex: 99,
  },
  closeButton: {
    position: 'absolute',
    bottom: '20px',
    right: '20px',
  },
  mainButon: {
    borderRadius: 6,
    fontFamily: 'IBM Plex Sans',
    fontSize: 14,
    fontWeight: 500,
    boxShadow: 'none',
    textTransform: 'none',
    border: 'solid 1px #97c1ff',
    color: '#044ada',
    marginTop: 30,
    padding: '10px 20px',
    cursor: 'pointer',
  },
}));


export default function CropButton() {
  const classe = useStyles();
  const [aberto, toggleAbrir] = useState(false);
  const [arquivo, setArquivo] = useState(undefined);

  const fechar = () => {
    toggleAbrir(false);
    setArquivo(undefined);
    // document.getElementById("formulario").reset();
  }

  const onChangeHandler = (event) => {
    const reader = new FileReader();
    if (reader) {
      reader.readAsDataURL(event.target.files[0])
      reader.onload = () => setArquivo(reader.result);
      toggleAbrir(true);
    }
  }

  return (
    <>
          <div id="formulario">
              {/* <label style={{ marginTop: 30 }} className={classe.mainButon} htmlFor="input-arquivo" role="button">Escolher foto</label> */}
              <input style={{ display: 'none' }} id="input-arquivo" type="file" name="file" accept=".jpg,.jpeg,.png" onChange={onChangeHandler} />
            </div>
          {aberto && (
<div className={classe.backModal}>
                <div className={classe.paper}>
                    <Button className={classe.closeButton} variant="contained" color="secondary" onClick={fechar}>X</Button>
                    <CropImage arquivo={arquivo} visible={aberto} />
                </div>
            </div>
)}
    </>
  );
}
